import React from 'react';
import GoBack from "../GoBack/GoBack";
import {withRouter} from 'react-router-dom';
import termsData from "../../assets/terms";
import {useStore} from "../../contexts/StateContext";

const Terms = function(props){

    const [{lang}] = useStore();

    return(
        <section className="container-inner">
            <GoBack history={ props.history } />
            <div className="terms" dangerouslySetInnerHTML={{__html: termsData[lang]}}/>
        </section>
    )
};

export default withRouter(Terms);